import { InputGroup } from '@/components/InputGroup'
import { FormLabel, Grid, Stack } from '@chakra-ui/react'
import { getGcpVoucherName, type Discount } from 'BrokerTsLib/src/dtos'
import { useEffect, useState } from 'react'

// Aktuálně používaný jen pro vouchery GČP - zadává se jen kód voucheru bez hodnoty slevy

const CheckboxVoucher = ({
  discount,
  onChange
}: {
  discount: Discount,
  onChange: (value: string) => void
}) => {

  const [voucherValue, setVoucherValue] = useState(discount.voucher)
  useEffect(() => {
    if (discount.voucher != voucherValue)
      setVoucherValue(discount.voucher)
  }, [discount.voucher])

  return (
    <Grid
      key={discount.insuranceCategoryDiscountId}
      templateColumns='1fr 1fr'
    >
      <Stack gap={1}>
        <FormLabel>
          {getGcpVoucherName(discount.type)}
        </FormLabel>
        
      </Stack>

      <InputGroup
        variant='filled'
        size='md'        
        sx={{ fontSize: 'md', fontWeight: 'bold'}}
        backgroundColor='white'
        value={voucherValue ?? ''}        
        onChange={(e) => {
          const val = e.target.value
          discount.voucher = val
          setVoucherValue(val)
          onChange(val)
        }}
      />
    </Grid>
  )
}

export default CheckboxVoucher